const reasons = [
  {
    title: "Prise en charge à domicile",
    highlight: "Incluse, dans toute la région genevoise",
    text: "Domicile, bureau ou parking : nous venons chercher la voiture et la ramenons réparée à l'adresse de votre choix. Vous n'avez pas besoin de passer à l'atelier.",
  },
  {
    title: "Véhicule de courtoisie",
    highlight: "Dès CHF 49.– par jour",
    text: "Une voiture récente pendant les travaux. Elle se réserve en même temps que le rendez-vous.",
  },
  {
    title: "Gestion de l'assurance",
    highlight: "Vous ne payez que la franchise",
    text: "Après l'expertise, nous envoyons le devis et les photos à votre assureur et suivons le dossier jusqu'à l'accord. Le reste est facturé directement à la compagnie.",
  },
];

const WhySection = () => (
  <section id="pourquoi" className="py-24 bg-muted/40 relative">
    <div className="container mx-auto px-4">
      <div className="mb-12 max-w-2xl">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Pendant les travaux</h2>
        <p className="text-muted-foreground">Ce qui est compris quand vous nous confiez votre voiture.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reasons.map((r) => (
          <div key={r.title} className="glass-card rounded-lg p-6">
            <h3 className="font-bold text-lg tracking-tight">{r.title}</h3>
            <p className="text-sm font-semibold text-primary mt-1 mb-4">{r.highlight}</p>
            <p className="text-sm text-muted-foreground leading-relaxed">{r.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhySection;
